import { createSelector } from "@reduxjs/toolkit";
import { Mode, ModeState } from "store/features/app/appSlice";
import { RootState } from "store/rootReducer";

export const selectMode = createSelector(
  (state: RootState) => state.groupBy?.globalGroupBy?.mode,
  (mode): ModeState =>
    mode ? { type: Mode.GroupEntity, field: mode.property } : { type: Mode.SingleEntity }
);
